import { useKindeAuth } from '@kinde-oss/kinde-auth-react'
import { wpAPI } from 'API/axiosConfig'
import { ILicenseTypes, initAPI } from 'API/init/api'
import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState
} from 'react'
import { toast } from 'react-toastify'
import {
  getLocalStorageData,
  removeLocalStorageData,
  setDataToLocalStorage
} from 'utils/localStorage'

export const WpContext = createContext(null as any)

export const useWpAuthContext = () => useContext(WpContext)

const USER_DATA = 'user_data'
const LICENSE = 'license'

export const WpAuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [authUser, setAuthUser] = useState(null)
  const { isAuthenticated, getIdToken, logout, isLoading } = useKindeAuth()
  const [licenseTypes, setLicenseTypes] = useState<ILicenseTypes | null>(null)
  const [currentLicense, setCurrentLicense] = useState<string>('')
  const lang = 'he'

  const getLicenseTypes = async () => {
    const data = await initAPI.getLicenseTypes(lang)
    if (data) {
      const license = Object.keys(data)[1]
      const storageLicense = getLocalStorageData(LICENSE)
      if (storageLicense) {
        setCurrentLicense(storageLicense)
      } else {
        setCurrentLicense(license)
        setDataToLocalStorage({ key: LICENSE, value: license })
      }
      setLicenseTypes(data)
    }
  }

  const wpUserData = async (token: string) => {
    const resp = await wpAPI.verifyToken(token)
    if (resp) {
      const sessionData = {
        key: USER_DATA,
        value: JSON.stringify(resp)
      }
      setAuthUser(resp)
      setDataToLocalStorage(sessionData)
    } else {
      toast.error('בעיות חיבור, אנא נסה שוב מאוחר יותר')
      setTimeout(() => {
        logout()
      }, 4000)
    }
  }

  const idToken = async () => {
    const token = await getIdToken()
    if (!token) return
    wpUserData(token)
  }

  useEffect(() => {
    if (licenseTypes) {
      if (!isLoading) {
        if (isAuthenticated) {
          idToken()
        } else {
          setAuthUser(null)
          removeLocalStorageData(USER_DATA)
        }
      }
    } else {
      getLicenseTypes()
    }
  }, [isAuthenticated, isLoading, licenseTypes])

  // useEffect(() => {

  // }, [licenseTypes])

  return (
    <WpContext.Provider
      value={{
        currentLicense,
        licenseTypes,
        lang,
        authUser,
        setCurrentLicense
      }}
    >
      {children}
    </WpContext.Provider>
  )
}
